import { useContext } from "react";
import PromptContextProvider from "../Context/PromptContext";

export default function usePrompt() {
  return useContext(PromptContextProvider);
}
